import { render, staticRenderFns } from "./webCam.vue?vue&type=template&id=37b9d5fc"
import script from "./webCam.vue?vue&type=script&lang=js"
export * from "./webCam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports